import { Navigate, RouteObject } from 'react-router-dom';

import { BlankLayout } from '@layouts/BlankLayout';
import { MainLayout } from '@layouts/MainLayout';

import { LoginPage } from '@pages/LoginPage';
import { FMainPage } from '@pages/funeral/FMainPage';
import { FOrderDetailPage } from '@pages/funeral/FOrderDetailPage';
import { FOrderListPage } from '@pages/funeral/FOrderListPage';
import { FUpsertOrderPage } from '@pages/funeral/FUpsertOrderPage';
import { PMainPage } from '@pages/partner/PMainPage';
import { PNoOrderListPage } from '@pages/partner/PNoOrderListPage';
import { POrderDetailPage } from '@pages/partner/POrderDetailPage';
import { PYesOrderListPage } from '@pages/partner/PYesOrderListPage';

import { AuthGuard } from '@plugins/react-router/AuthGuard';

import { DefaultErrorBoundary } from '@/errorboundary/DefaultErrorBoundary';

export const mainRouter: RouteObject[] = [
  {
    path: '*',
    element: <AuthGuard />,
    children: [
      {
        path: '*',
        element: <MainLayout />,
        errorElement: <DefaultErrorBoundary />,
        children: [
          {
            path: 'funeral',
            element: <BlankLayout />,
            errorElement: <DefaultErrorBoundary />,
            children: [
              { path: '', element: <Navigate to='/funeral/main' /> },
              {
                path: 'main',
                element: <FMainPage />,
                errorElement: <DefaultErrorBoundary />,
              },
              {
                path: 'orders',
                element: <FOrderListPage />,
                errorElement: <DefaultErrorBoundary />,
              },
              {
                path: 'new-order',
                element: <FUpsertOrderPage />,
                errorElement: <DefaultErrorBoundary />,
              },
              {
                path: 'orders/:orderId',
                element: <FOrderDetailPage />,
                errorElement: <DefaultErrorBoundary />,
              },
              {
                path: 'orders/:orderId/edit',
                element: <FUpsertOrderPage />,
                errorElement: <DefaultErrorBoundary />,
              },
              { path: '*', element: <Navigate to='/funeral/main' /> },
            ],
          },
          {
            path: 'partner',
            element: <BlankLayout />,
            errorElement: <DefaultErrorBoundary />,
            children: [
              { path: '', element: <Navigate to='/partner/main' /> },
              {
                path: 'main',
                element: <PMainPage />,
                errorElement: <DefaultErrorBoundary />,
              },
              {
                path: 'unknown-orders',
                element: <PNoOrderListPage />,
                errorElement: <DefaultErrorBoundary />,
              },
              {
                path: 'accept-orders',
                element: <PYesOrderListPage />,
                errorElement: <DefaultErrorBoundary />,
              },
              {
                path: 'orders/:orderId',
                element: <POrderDetailPage />,
                errorElement: <DefaultErrorBoundary />,
              },
              { path: '*', element: <Navigate to='/partner/main' /> },
            ],
          },
          {
            path: 'permisson-denied',
            element: <DefaultErrorBoundary />,
            errorElement: <DefaultErrorBoundary />,
          },
        ],
      },
    ],
  },
  {
    path: 'login',
    element: <BlankLayout />,
    children: [
      {
        path: '',
        element: <LoginPage />,
        errorElement: <DefaultErrorBoundary />,
      },
    ],
  },
];
